import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopPosition(props) {
  const { open, close } = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['2023, 05, 12 이사', '2022, 01, 23 부장', '2020, 12, 20 차장', '2021, 09, 10 사원','2023, 05, 12 이사', '2022, 01, 23 부장', '2020, 12, 20 차장', '2021, 09, 10 사원'];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input" popSize="xs">
      <h2 className='pop_tit'>직급 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="input_field">
            <select className="select">
              <option value="부장">부장</option>
            </select>
          </li>
          <li className="tit_field">진급일</li>
          <li className="input_field">
            <input type="date" className="com_datepicker" defaultValue={`2022-01-01`} />
          </li>
        </ul>
        <ul className="com_scroll_list pick">
          {listItems.map((item, index) => (
            <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => handleClick(index)}>
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopPosition;